<div class="timesheets-page">
  <div class="page-head">
    <div class="title-block">
      <h1 class="page-title">
        Timesheets
        <span class="count-chip" *ngIf="totalTimesheetCount">{{totalTimesheetCount}}</span>
      </h1>
      <p class="lede" *ngIf="user?.role_uuid === ROLES.AGENCY">Approve, reject and review timesheets across every client
        and
        job.</p>
      <p class="lede" *ngIf="user?.role_uuid === ROLES.CLIENT">Review and approve timesheets submitted for your jobs.
      </p>
      <p class="lede" *ngIf="user?.role_uuid === ROLES.CANDIDATE">Submit your hours and track approvals for every
        assignment.</p>
    </div>

    <!-- DEFAULT actions -->
    <div class="action-bar" *ngIf="selectedCount === 0">
      <button type="button" class="btn btn-secondary" (click)="exportTimeSheet(false)">
        <i class="bi bi-download"></i><span>Export</span>
      </button>
      <button class="btn btn-primary" *ngIf="user?.role_uuid === ROLES.AGENCY" (click)="onImport()">
        <i id="add" class="bi bi-cloud-download me-2"></i>
        Import Timesheets
      </button>
      <button type="button" class="btn btn-primary" *ngIf="user?.role_uuid === ROLES.CANDIDATE"
        (click)="createTimesheet()">
        <i class="bi bi-plus-lg"></i><span>Add Timesheet</span>
      </button>
    </div>

    <!-- BULK actions -->
    <div class="action-bar" *ngIf="selectedCount > 0">
      <span class="selected-text">
        <i class="bi bi-check2-square"></i>{{selectedCount}} selected
      </span>
      <button [disabled]="loading || !isAllSelectedIsSubmitted()" (click)="onApproveAll()" class="btn btn-approve"
        [matTooltip]="!isAllSelectedIsSubmitted() ? 'Only Submitted timesheets can be approved' : ''">
        <i class="bi bi-clipboard2-check"></i><span>Approve</span>
      </button>
      <button [disabled]="loading || !isAllSelectedIsSubmitted()" (click)="onRejectAll()" class="btn btn-reject"
        [matTooltip]="!isAllSelectedIsSubmitted() ? 'Only Submitted timesheets can be rejected' : ''">
        <i class="bi bi-clipboard2-x"></i><span>Reject</span>
      </button>
      <button [disabled]="loading" class="btn btn-secondary" (click)="exportTimeSheet(true)">
        <i class="bi bi-download"></i><span>Export selected</span>
      </button>
      <button class="btn btn-text" (click)="clearSelection()">Clear</button>
    </div>
  </div>

  <div class="card" #mainContainer [ngClass]="isOpen ? 'ownShadow':''">

    <!-- Filter bar -->
    <div class="card-header">
      <div class="input-group">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Search client, job, contractor…" [(ngModel)]="searchText"
          (input)="onSearch()" />
      </div>

      <!-- Date filter chip -->
      <div class="filter-chip">
        <i class="bi bi-calendar3"></i>
        <mat-form-field appearance="legacy" class="datePickerStyle">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="start_date" placeholder="Start Date">
            <input matEndDate [(ngModel)]="end_date" placeholder="End Date" (dateChange)="dateChanged($event)">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker touchUi="true" #picker></mat-date-range-picker>
        </mat-form-field>
        <mat-select panelClass="matRole timesheetDateFilterPanel" class="filter-select" role="button"
          (selectionChange)="onFilterChange(picker)" [(ngModel)]="selectedFilterOption">
          <mat-option>Recently Submmitted</mat-option>
          <mat-option [value]="option.label" *ngFor="let option of filterOptions">{{option.label}}</mat-option>
          <mat-option value="datePicker" (click)="onFilterChange(picker)">Date picker</mat-option>
          <mat-option value="{{custom_datepicker_text}}" class="d-none">{{custom_datepicker_text}}</mat-option>
        </mat-select>
      </div>

      <!-- Status filter chip -->
      <div class="filter-chip">
        <i class="bi bi-funnel"></i>
        <mat-select panelClass="matRole statusFilterPanel" class="filter-select" role="button"
          placeholder="All Statuses" (selectionChange)="onStatusFilterChange($event)" [(ngModel)]="selectedStatusFilter"
          [multiple]="true">
          <mat-option *ngFor="let status of timesheetService.statusArr" [value]="status">{{status}}</mat-option>
        </mat-select>
      </div>

      <a class="btn btn-text clear-link" *ngIf="searchText || selectedStatusFilter.length > 0" (click)="clearFilters()">
        <i class="bi bi-x-lg"></i><span>Clear</span>
      </a>

      <button type="button" class="icon-btn refresh-btn" matTooltip="Refresh" (click)="onRefresh()"
        [disabled]="loading">
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>

    <!-- Loading -->
    <div class="card-loader" *ngIf="loading">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <div class="table-responsive">
      <table matSort (matSortChange)="sortData($event)" class="table">
        <thead *ngIf="timesheet_fields && timesheet_fields?.length > 0">
          <tr>
            <th scope="col" class="select-col"
              *ngIf="user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT">
              <input (change)="onSelectAll()" [(ngModel)]="selectAll" type="checkbox"
                matTooltip="Select all on this page">
            </th>
            <ng-container *ngFor="let field of timesheet_fields" [ngSwitch]="field?.label">
              <th mat-sort-header="job" scope="col" *ngSwitchCase="'Job'">Job</th>
              <th mat-sort-header="candidate" scope="col" *ngSwitchCase="'Contractor'">Contractor</th>
              <th mat-sort-header="client" scope="col" *ngSwitchCase="'Client'">Client</th>
              <th mat-sort-header="start_date" scope="col" *ngSwitchCase="'Start Date'">Start Date</th>
              <th mat-sort-header="end_date" scope="col" *ngSwitchCase="'End Date'">End Date</th>
              <th mat-sort-header="status" scope="col" *ngSwitchCase="'Status'">Status</th>
              <th scope="col" *ngSwitchCase="'Work Duration'">Work Duration</th>
              <th scope="col" *ngSwitchCase="'Time Unit'">Time Unit</th>
              <ng-container *ngSwitchCase="'Hours'">
                <th scope="col" th_switchcase="Hours">Total Hours</th>
              </ng-container>
              <ng-container *ngSwitchCase="'Days'">
                <th scope="col" th_switchcase="Days">Total Days</th>
              </ng-container>
              <ng-container *ngSwitchCase="'Start Time'">
                <th scope="col" th_switchcase="Start Time">Total Hours</th>
              </ng-container>
            </ng-container>
            <th scope="col" class="actions-col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!loading && sortedTimesheet?.length === 0">
            <tr class="empty-row">
              <td [attr.colspan]="(timesheet_fields?.length || 0) + 2">
                <div class="empty-state">
                  <div class="empty-icon"><i class="bi bi-clipboard2-x"></i></div>
                  <h3>No timesheets match your filters</h3>
                  <p>Try clearing your search or adjusting the date and status filters.</p>
                </div>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="sortedTimesheet && sortedTimesheet.length > 0">
            <tr class="dataColumn" *ngFor="let timesheet of sortedTimesheet" [class.row-selected]="timesheet.selected">
              <td class="select-col" (click)="$event.stopPropagation()"
                *ngIf="user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT">
                <input (change)="onSingleSelect()" [(ngModel)]="timesheet.selected" type="checkbox"
                  [disabled]="timesheet.status === STATUS.APPROVED">
              </td>
              <ng-container *ngFor="let field of timesheet_fields" [ngSwitch]="field?.label">
                <td *ngSwitchCase="'Job'"
                  (click)="this.permissions.assignments?redirectAssignments('/assignments', timesheet.job) : openTimesheetDetails(timesheet, timesheet.status, true)">
                  <div class="cell-with-icon">
                    <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
                    <span class="cell-text">{{timesheet.job}}</span>
                  </div>
                </td>
                <td *ngSwitchCase="'Contractor'"
                  (click)="permissions?.candidates?redirect('/candidates', timesheet.candidate) : openTimesheetDetails(timesheet, timesheet.status, true)">
                  <div class="contractor-cell">
                    <div class="avatar" *ngIf="timesheet.profile_pic">
                      <img src="{{dataSharedService.getImage(timesheet.profile_pic)}}" alt="" />
                    </div>
                    <div class="avatar avatar-initials" *ngIf="!timesheet.profile_pic">
                      <span>{{authService.getInitials(timesheet.candidate)}}</span>
                    </div>
                    <span class="contractor-name">{{timesheet.candidate}}</span>
                  </div>
                </td>
                <td *ngSwitchCase="'Client'"
                  (click)="permissions?.clients?redirect('/clients', timesheet.client) : openTimesheetDetails(timesheet, timesheet.status, true)">
                  <div class="cell-with-icon">
                    <span class="cell-icon"><i class="bi bi-people"></i></span>
                    <span class="cell-text">{{timesheet.client}}</span>
                  </div>
                </td>
                <td *ngSwitchCase="'Start Date'" (click)="openTimesheetDetails(timesheet, timesheet.status, true)">
                  {{dataSharedService.tranformDate(timesheet.start_date)}}
                </td>
                <td *ngSwitchCase="'End Date'" (click)="openTimesheetDetails(timesheet, timesheet.status, true)">
                  {{dataSharedService.tranformDate(timesheet.end_date)}}
                </td>
                <td *ngSwitchCase="'Status'" (click)="openTimesheetDetails(timesheet, timesheet.status, true)">
                  <span class="pill" [class.approved]="timesheet.status === STATUS.APPROVED"
                    [class.submitted]="timesheet.status === STATUS.SUBMITTED"
                    [class.pending]="timesheet.status === STATUS.PENDING"
                    [class.rejected]="timesheet.status === STATUS.REJECTED">
                    <i class="bi" [ngClass]="
                        timesheet.status === STATUS.APPROVED ? 'bi-check-circle-fill' :
                        timesheet.status === STATUS.SUBMITTED ? 'bi-record-circle-fill' :
                        timesheet.status === STATUS.PENDING ? 'bi-stopwatch-fill' :
                        timesheet.status === STATUS.REJECTED ? 'bi-x-circle-fill' : ''"></i>
                    <span>{{timesheet.status}}</span>
                  </span>
                </td>
                <ng-container *ngIf="agency_uuid === AGENCY.HYPHEN">
                  <ng-container *ngSwitchCase="'Work Duration'">
                    <td (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                      <div class="hyphen-cell">
                        <span>{{timesheet?.fields[0]?.days ? timesheet.fields[0].days :''}}</span>
                        <span>{{timesheet?.fields[0]?.hours ? timesheet.fields[0].hours :''}}</span>
                      </div>
                    </td>
                  </ng-container>
                  <ng-container *ngSwitchCase="'Time Unit'">
                    <td (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                      <div class="hyphen-cell">
                        <span>{{timesheet?.fields[1]?.days ? timesheet.fields[1].days :''}}</span>
                        <span>{{timesheet?.fields[1]?.hours ? timesheet.fields[1].hours :''}}</span>
                      </div>
                    </td>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Hours'">
                  <td td_switchcase="Hours" class="numeric"
                    (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                    {{timesheet.total_hours}}
                  </td>
                </ng-container>
                <ng-container *ngSwitchCase="'Days'">
                  <td td_switchcase="Days" class="numeric"
                    (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                    {{timesheet.total_days}}
                  </td>
                </ng-container>
                <ng-container *ngSwitchCase="'Start Time'">
                  <td td_switchcase="Start Time" class="numeric"
                    (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                    {{timesheet.total_hours}}
                  </td>
                </ng-container>
              </ng-container>
              <td class="td-actions">
                <div class="row-actions">
                  <button class="icon-btn-sm approve"
                    *ngIf="timesheet.status === STATUS.SUBMITTED && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT)"
                    matTooltip="Approve" (click)="onApprove(timesheet.uuid); $event.stopPropagation()">
                    <i class="bi bi-clipboard2-check"></i>
                  </button>
                  <button class="icon-btn-sm reject"
                    *ngIf="timesheet.status === STATUS.SUBMITTED && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT)"
                    matTooltip="Reject" (click)="onReject(timesheet.uuid); $event.stopPropagation()">
                    <i class="bi bi-clipboard2-x"></i>
                  </button>
                  <button class="icon-btn-sm" matTooltip="View"
                    (click)="openTimesheetDetails(timesheet, timesheet.status, true); $event.stopPropagation()">
                    <i class="bi bi-eye-fill"></i>
                  </button>
                  <mat-select style="width: 0;" #singleTimesheetOptions class="singleTimesheetOptionsSelect"
                    panelClass="matRole" role="button">
                    <mat-option
                      *ngIf="((timesheet.status !== STATUS.APPROVED) && (user.role_uuid === ROLES.CANDIDATE || user.role_uuid === ROLES.AGENCY))">
                      <a class="dropdown-item btn" (click)="openTimesheetDetails(timesheet, timesheet.status, false)">
                        Edit Timesheet
                      </a>
                    </mat-option>
                    <mat-option (click)="deleteTimesheet(timesheet.uuid)"
                      *ngIf="(user.role_uuid === ROLES.CANDIDATE || user.role_uuid === ROLES.AGENCY)">
                      <a class="dropdown-item btn">Delete Timesheet</a>
                    </mat-option>
                    <mat-option
                      *ngIf="timesheet.status === STATUS.SUBMITTED && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT)">
                      <a class="dropdown-item btn" (click)="openTimesheetApprovalLinks(timesheet.uuid)">
                        Approval Link
                      </a>
                    </mat-option>
                    <mat-option
                      *ngIf="timesheet.status === STATUS.APPROVED && (user.role_uuid === ROLES.AGENCY || user.role_uuid === ROLES.CLIENT)">
                      <a class="dropdown-item btn" (click)="openTimesheetViewLink(timesheet.uuid)">
                        View Link
                      </a>
                    </mat-option>
                    <mat-option *ngIf="timesheet.status === STATUS.APPROVED && (user.role_uuid === ROLES.CANDIDATE)">
                      <a class="dropdown-item btn" (click)="sendTimesheetInvoice(timesheet.uuid)">
                        Send Invoice
                      </a>
                    </mat-option>
                  </mat-select>
                  <button class="icon-btn-sm" matTooltip="More options"
                    (click)="singleTimesheetOptions.open(); $event.stopPropagation()">
                    <i class="bi bi-three-dots"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="card-pagination" *ngIf="totalTimesheetCount">
      <span class="pagination-summary">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalTimesheetCount }} timesheets
      </span>
      <app-api-paginator [totalCount]="totalTimesheetCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
    </div>

  </div>
</div>